import { j as e } from "../../jsx-runtime-p91LotPX.mjs";
import { GrowButton as a } from "../Button/AntButton.js";
const n = {
  save: "Save",
  cancel: "Cancel",
  saving: "Saving"
};
function s(t) {
  const {
    text: o = n.save,
    savingText: i = n.saving
  } = t;
  return /* @__PURE__ */ e.jsx(a, { type: "primary", ...t, children: t.loading ? i : o });
}
function u(t) {
  return /* @__PURE__ */ e.jsx(a, { type: "text", ...t, children: n.cancel });
}
export {
  u as CancelButton,
  s as SaveButton
};
//# sourceMappingURL=ActionButtons.js.map
